import { Link, Text, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useTranslation, Trans } from 'react-i18next';
import MaintenancePageIllustration from './assets/maintenance-page-image.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  background: ${tokens.BRAND_COLORS.white};
`;

const Wrapper = styled.div`
  width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const TextWrapper = styled.div`
  max-width: 350px;
  margin-top: 32px;
`;

const Img = styled.img`
  width: 80%;
  margin-bottom: ${tokens.spacer.x3};
`;

interface LinkTextProps {
  href: string;
  children?: string;
}

const LinkText = ({ href, children }: LinkTextProps) => {
  return (
    <Link href={href || ''} kind="inline" isExternal>
      {children as string}
    </Link>
  );
};

export const MaintenancePage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <Wrapper>
        <Img src={MaintenancePageIllustration} alt="Hotjar" />
        <Text as="h4" textType="header4">
          {t('common:maintenance-page.title')}
        </Text>
        <TextWrapper>
          <Text as="p" textType="body1">
            <Trans
              i18nKey="common:maintenance-page.body"
              t={t}
              components={[
                <LinkText href="https://mobile.twitter.com/hotjar_status" />,
                <LinkText href="https://status.hotjar.com/" />,
              ]}
            />
          </Text>
        </TextWrapper>
      </Wrapper>
    </Container>
  );
};
